/* js/scrollreveal.js */

(function ($, window, document) {
    
    $(window).on('load', function () {
        
        if (typeof initScrollReveal !== 'undefined') {
            initScrollReveal();
        }
    
        function initScrollReveal() {
        
            var _targets = '.reveal';
            var _rotate = '.rotate';

            if (typeof ScrollReveal === 'function') {
                window.sr = ScrollReveal();
                sr.reveal(_targets, {
                    duration: 2000,
                    origin: 'bottom',
                    distance: '60px',
                    scale: 0.9
                });
            }

            if (typeof ScrollReveal === 'function') {
                window.sr = ScrollReveal();
                sr.reveal(_rotate, {
                    duration: 2000,
                    reset: true,
                    rotate: {
                        x: 10,
                        y: 90,
                        z: 0
                    }
                });
            }
        
        }
        
        
    });

})(jQuery, window, document);
